<template>
  <div class="resource">
    <!-- 确认提示框 -->
    <el-dialog title="温馨提示" :visible.sync="dialogVisible" width="30%">
      <span>此时需要先登录才能继续操作哦</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="goLogin">去登录</el-button>
      </span>
    </el-dialog>

    <div class="progress-container" v-if="progress > 0">
      <div class="progress-bar" :style="{ width: progress + '%' }">
        <span>{{ progress }}%</span>
      </div>
    </div>

    <header class="resource-header">
      <div><h1>图书资源包</h1><p>浏览资源内容，购买后即可下载使用。</p></div>
      <span class="resource-total">共 {{ list.length }} 个资源</span>
    </header>
    <div class="tips">
      大文件下载可能需要一些时间，请保持页面打开。下载异常时，可至首页联系客服。
    </div>

    <div class="flexBlock">
      <div
        v-for="item in list"
        :key="item.id"
        class="api-item"
      >
        <div class="download-count">
          {{ item.downloadCount || 0 }} 次下载
        </div>

        <img
          class="api-item-image"
          :src="item.imgUrl"
          :alt="item.name"
          :title="item.name"
        />
        <p class="api-item-name">{{ item.name }}</p>
        <div class="api-item-desc">
          {{ item.remark }}
        </div>

        <div class="resource-action">
        <div v-if="!item.payFlag" class="api-item-price">
          ¥{{ item.priceStr }}
        </div>
        <span v-else class="purchased-label">已购买</span>

        <button
          class="api-item-btn api-item-btn-download"
          v-if="item.payFlag"
          @click="(e) => goDownload(e, item.id, item.name)"
        >
          下载资源
        </button>
        <button class="api-item-btn" v-else @click="goPay(item.id)">
          购买资源
        </button>
        </div>
      </div>
    </div>

    <div class="qrCode">
      <el-dialog
        title="支付二维码"
        :visible.sync="showDialog"
        width="40%"
        custom-class="custom-dialog"
        @close="closeDialog"
      >
        <div class="qr-code-container">
          <img :src="qrCodeUrl" alt="支付二维码" v-if="qrCodeUrl" />
          <p>
            请使用<span style="color: red; font-weight: 700">“微信”</span
            >扫描二维码完成支付
          </p>
        </div>
        <span slot="footer" class="dialog-footer"> </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getList, goPay } from '@/api/resource'
import { mapGetters } from 'vuex'

import QRCode from 'qrcode'
import { getByOrderNo } from '@/api/pay'
import axios from 'axios'
export default {
  data () {
    return {
      progress: 0,
      dialogVisible: false,
      list: [],
      qrCodeUrl: null,
      showDialog: false,
      timerId: null
    }
  },
  methods: {
    closeDialog () {
      if (this.timerId) {
        console.log('关闭定时器：' + this.timerId)
        clearInterval(this.timerId)
      }
    },
    goLogin () {
      this.dialogVisible = false
      this.$router.replace({
        path: '/login',
        query: {
          backUrl: this.$route.fullPath
        }
      })
    },
    async goPay (id) {
      const token = this.$store.getters.token
      // 未登录
      if (!token) {
        this.dialogVisible = true
        return
      }
      // 调用获取方法
      const result = await goPay(id)
      try {
        const url = await QRCode.toDataURL(result.data.codeUrl)
        this.qrCodeUrl = url
      } catch (err) {
        console.error('生成二维码失败:', err)
        return
      }
      this.showDialog = true

      // 开启定时器轮询查订单状态，若支付成功则关闭弹层，跳转到我的api页面
      this.timerId = setInterval(async () => {
        const orderObj = await getByOrderNo(result.data.orderNo)
        if (orderObj && orderObj.data && orderObj.data.orderStatus === 60) {
          this.showDialog = false
          clearInterval(this.timerId)
          this.$router.push('/resourceDownload').catch((err) => {
            if (err.name !== 'NavigationDuplicated') {
              throw err // 重新抛出其他类型的错误
            }
          })
          this.$toast.success('支付成功')
        }
      }, 2000)
    },
    async goDownload (event, id, name) {
      const token = this.$store.getters.token
      // 未登录
      if (!token) {
        this.dialogVisible = true
        return
      }
      event.target.disabled = true
      event.target.classList.add('api-item-btn-download-disabled')

      try {
        this.$toast.loading({
          message: '下载中，请勿离开此页面...',
          forbidClick: true, // 禁止背景点击
          duration: 0, // 时长，不会自动消失
          loadingType: 'spinner' // 图标
        })
        const response = await axios({
          url: 'https://data.isbn.work/file/download/' + id,
          method: 'GET',
          headers: {
            Authorization: 'Bearer ' + token
          },
          responseType: 'blob', // 重要：设置响应类型为blob
          onDownloadProgress: (progressEvent) => {
            this.progress = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            )
          }
        })

        // 处理下载文件
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', name) // 设置下载文件名
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
        event.target.disabled = false
        event.target.classList.remove('api-item-btn-download-disabled')

        this.$toast.success('下载成功')
      } catch (error) {
        this.$toast.fail('下载发生错误，请联系管理员')
      } finally {
        this.progress = 0
      }

      // const response = await goDownload(id)
    }
  },
  async created () {
    const result = await getList(this.getUserId)
    this.list = result.data
  },
  computed: {
    ...mapGetters(['getUserId'])
  },
  destroyed () {
    if (this.timerId) {
      console.log('关闭定时器：' + this.timerId)
      clearInterval(this.timerId)
    }
  }
}
</script>

<style lang="less" scoped>
.resource {
  margin: 0 auto;
  width: 1000px;
  h1 {
    padding: 10px 10px 10px;
  }
  .tips {
    color: orangered;
    font-size: 12px;
    margin: 0 10px 10px 10px;
  }
  .flexBlock {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .api-item {
      width: 232px;
      height: 260px;
      border: 1px solid #eee;
      border-radius: 5px;
      margin: 0 9px 22px;
      text-align: center;
      padding-top: 20px;
      position: relative;
      box-shadow: 0 3px 10px 0 hsla(0, 0%, 60.8%, 0.16);
      .download-count {
        font-size: 12px;
        color: #fff;
        width: 80px;
        height: 20px;
        padding: 2px 2px;
        position: absolute;
        top: 10px;
        right: -9px;
        background-color: rgb(240, 161, 132);
        border-radius: 5px;
      }
      .api-item-image {
        width: 50px;
        height: 50px;
        object-fit: contain;
      }
      .api-item-price {
        position: absolute;
        bottom: 52px;
        left: 0;
        right: 0;
        margin: 0 auto;
        color: #ff5441;
        font-size: 16px;
        font-weight: 600;
      }
      .api-item-original-price {
        left: 0;
        right: 0;
        margin: 0 auto;
        position: absolute;
        bottom: 75px;
        color: #9b9696;
        font-size: 13px;
        width: 75px;
      }
      .api-item-original-price::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 0;
        right: 0; /* 从左到右占据整个容器宽度 */
        height: 1px; /* 删除线的高度 */
        background-color: #9b9696; /* 删除线的颜色 */
        transform: translateY(-50%); /* 垂直居中 */
      }
      .api-item-name {
        color: #666;
        font-size: 14px;
        font-weight: bold;
      }
      .api-item-desc {
        padding: 8px 14px 0;
        font-size: 12px;
        color: #999;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
      }
      .api-item-btn {
        position: absolute;
        left: 10%;
        bottom: 20px;
        width: 80%;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background-color: #00bdff;
        border-radius: 6px;
        cursor: pointer;
        color: #fff;
        border: none;
      }
      .api-item-btn-download {
        background-color: burlywood;
      }
      .api-item-btn-download-disabled {
        background-color: rgb(182, 180, 178);
      }
    }
  }

  .progress-container {
    width: 100%;
    background-color: #f3f3f3;
    border-radius: 5px;
    overflow: hidden;
    margin: 20px 0;
    height: 20px;
    .progress-bar {
      position: relative;
      height: 100%;
      width: 0;
      background-color: #4caf50;
      transition: width 0.5s ease-in-out;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      box-sizing: border-box;
      span {
        position: absolute;
        right: 5px;
        color: white;
        font-size: 14px;
      }
    }
  }
}

/* 移动端适配 - 不影响PC端 */
@media screen and (max-width: 768px) {
  .resource {
    width: 100%;
    padding: 12px;

    h1 {
      font-size: 18px;
      padding: 10px 0;
    }

    .tips {
      font-size: 11px;
      margin: 0 0 10px 0;
    }

    .flexBlock {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 0 6px;

      .api-item {
        width: calc(50% - 12px);
        min-height: 220px;
        margin: 0 6px 16px;
        padding-top: 15px;

        .download-count {
          font-size: 10px;
          width: 65px;
          height: 18px;
          top: 8px;
          right: -8px;
        }

        .api-item-image {
          width: 40px;
          height: 40px;
        }

        .api-item-name {
          font-size: 13px;
        }

        .api-item-desc {
          font-size: 11px;
          padding: 5px 10px 0;
          -webkit-line-clamp: 2;
        }

        .api-item-price {
          font-size: 14px;
          bottom: 48px;
        }

        .api-item-original-price {
          font-size: 11px;
          bottom: 68px;
          width: 65px;
        }

        .api-item-btn {
          height: 26px;
          line-height: 26px;
          bottom: 15px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
<style lang="less" scoped>
// 内容和操作使用正常文档流，长说明不会与价格、按钮重叠。
.resource {
  width: 100%; max-width: 1200px; padding: 24px; background: #fbfcfe;
  .resource-header { display: flex; align-items: center; justify-content: space-between; gap: 16px; margin-bottom: 16px; }
  .resource-header h1 { padding: 0; font-size: 26px; color: #46566c; }
  .resource-header p { color: #68798c; font-size: 13px; margin-top: 6px; }
  .resource-total { color: #68798c; font-size: 12px; white-space: nowrap; }
  .tips { margin: 0 0 20px; padding: 10px 14px; background: #f0f7ff; color: #63758b; border-radius: 6px; line-height: 1.7; }
  .flexBlock { display: grid; grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); gap: 16px; padding: 0; }
  .flexBlock .api-item {
    width: 100%; height: auto; min-height: 250px; margin: 0; padding: 18px;
    display: flex; flex-direction: column; align-items: flex-start;
    text-align: left; background: #fff; border: 1px solid #eaf0f6; border-radius: 10px; box-shadow: 0 2px 10px rgba(74, 117, 170, 0.04);
    .download-count { position: static; order: -1; align-self: flex-end; width: auto; height: auto; background: #f0f4f8; color: #68798c; padding: 3px 8px; border-radius: 4px; font-size: 11px; }
    .api-item-image { width: 48px; height: 48px; margin: 0 0 12px; }
    .api-item-name { font-size: 16px; line-height: 1.5; color: #46566c; font-weight: 500; overflow-wrap: anywhere; }
    .api-item-desc { display: block; padding: 8px 0 16px; color: #68798c; font-size: 13px; line-height: 1.7; overflow-wrap: anywhere; }
    .resource-action { width: 100%; display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 10px; margin-top: auto; padding-top: 14px; border-top: 1px solid #edf0f4; }
    .api-item-price { position: static; margin: 0; color: #507499; font-size: 22px; font-weight: 500; font-variant-numeric: tabular-nums; }
    // 浅色内容区域搭配高对比实色按钮，保持操作入口醒目。
    .api-item-btn { position: static; width: auto; height: 36px; line-height: 36px; padding: 0 16px; white-space: nowrap; background: #1769d2; color: #fff; font-size: 13px; font-weight: 600; }
    .api-item-btn:hover { background: #1258b5; }
    .api-item-btn-download { background: #087e64; }
    .api-item-btn-download:hover { background: #066750; }
    .api-item-btn:disabled { background: #e6ebf1; color: #7a8796; cursor: wait; }
    .purchased-label { color: #367565; background: #edf8f3; padding: 3px 8px; border-radius: 4px; font-size: 12px; }
  }
}
@media screen and (max-width: 768px) {
  .resource {
    padding: 16px 12px;
    .resource-header { align-items: flex-start; margin-bottom: 12px; }
    .resource-header h1 { font-size: 21px; }
    .resource-header p { font-size: 12px; }
    .resource-total { padding-top: 6px; }
    .tips { margin-bottom: 12px; padding: 8px 10px; font-size: 11px; }
    .flexBlock { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; }
    .flexBlock .api-item {
      min-height: 220px; padding: 12px;
      .api-item-image { width: 38px; height: 38px; margin-bottom: 8px; }
      .api-item-name { font-size: 14px; }
      .api-item-desc { font-size: 12px; padding-bottom: 12px; }
      .resource-action { gap: 8px; padding-top: 10px; }
      .api-item-price { font-size: 19px; }
      .api-item-btn { height: 32px; line-height: 32px; padding: 0 10px; font-size: 12px; }
    }
  }
}
</style>
